import EcoImg from 'eco-design/base/eco-img';
import EcoSpace from 'eco-design/base/eco-space';
import { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import Tabs from '../Tabs';
import { AnimatedGrid } from '../AnimatedSection';
import CommonTitle from '../CommonTitle';
import styles from './index.module.scss';
import { useLang } from '@/app/utils/useLang';
import useDeviceDetect from '@/utils/hooks/useDeviceDetect';
import getLocal from 'eco-design-reliance/getLocal';

const ChargeUp: React.FC = () => {
    const { t } = useLang('ChargeUp');
    const { isH5 } = useDeviceDetect();
    const swiperRef = useRef<any>(null);
    const { locale = 'us' } = getLocal();
    const isEu = ['eu', 'uk', 'de', 'fr', 'es', 'it', 'nl'].includes(locale)
    const [activeIndex, setActiveIndex] = useState(0);

    let tabs = [
        {
            tabLabel: t.rich('tab1', {
                sup: (text: string) => <sup>{text}</sup>,
            }),
            tabValue: 'tab1',
            desc: t.rich('tab1_desc', {
                sup: (text: string) => <sup>{text}</sup>,
            }),
            isVideo: true,
            pc: 'https://websiteoss.ecoflow.com/upload/video/1759044286523/PC%E6%AF%94%E4%BE%8B-1%E5%BA%A6.mp4',
            h5: 'https://websiteoss.ecoflow.com/upload/video/1759044292174/M%E6%AF%94%E4%BE%8B-1%E5%BA%A6.mp4',

            pcPoster: 'https://websiteoss.ecoflow.com/figma-uploads/1758336613480-w5nwcr-compressed-PC%E6%AF%94%E4%BE%8B-1%E5%BA%A6%20(0-00-02-17).jpg',
            h5Poster: 'https://websiteoss.ecoflow.com/figma-uploads/1758336638025-qs2i2c-compressed-M%E6%AF%94%E4%BE%8B-1%E5%BA%A6%20(0-00-02-17).jpg',
        },
        {
            tabLabel: t.rich('tab2', {
                sup: (text: string) => <sup>{text}</sup>,
            }),
            tabValue: 'tab2',
            desc: t.rich('tab2_desc', {
                sup: (text: string) => <sup>{text}</sup>,
            }),
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758601220115-s1ci93-compressed-Generator%20charging.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758601239045-lynuel-compressed-Generator%20charging.jpg',
        },
        {
            tabLabel: t.rich('tab3', {
                sup: (text: string) => <sup>{text}</sup>,
            }),
            tabValue: 'tab3',
            desc: t.rich('tab3_desc', {
                sup: (text: string) => <sup>{text}</sup>,
            }),
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758601151512-ihd09m-compressed-20250828%E9%9C%B2%E8%90%A515621.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758601198182-g13grk-compressed-Solar%20Charging%20.jpg',
        },
        {
            tabLabel: t.rich('tab4', {
                sup: (text: string) => <sup>{text}</sup>,
            }),
            tabValue: 'tab4',
            desc: t.rich('tab4_desc', {
                sup: (text: string) => <sup>{text}</sup>,
            }),
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758601271382-kg5apw-compressed-Car%20Charging.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758601253451-gome75-compressed-Car%20Charging%20.jpg',
        },
    ];
    if (isEu) {
        tabs = [
            {
                tabLabel: t.rich('tab1', {
                    sup: (text: string) => <sup>{text}</sup>,
                }),
                tabValue: 'tab1',
                desc: t.rich('tab1_desc', {
                    sup: (text: string) => <sup>{text}</sup>,
                }),
                pc: locale === 'uk' ? 'https://websiteoss.ecoflow.com/upload/image/1774858323415/UK-1.jpg' : 'https://websiteoss.ecoflow.com/upload/image/1774857695632/11.jpg',
                h5: locale === 'uk' ? 'https://websiteoss.ecoflow.com/upload/image/1774858324025/UK-M-1.jpg' : 'https://websiteoss.ecoflow.com/upload/image/1774858279980/M11.jpg',
            },
            {
                tabLabel: t.rich('tab2', {
                    sup: (text: string) => <sup>{text}</sup>,
                }),
                tabValue: 'tab2',
                desc: t.rich('tab2_desc', {
                    sup: (text: string) => <sup>{text}</sup>,
                }),
                pc: locale === 'uk' ? 'https://websiteoss.ecoflow.com/upload/image/1774858324429/UK-2.jpg' : 'https://websiteoss.ecoflow.com/upload/image/1774857695231/22.jpg',
                h5: locale === 'uk' ? 'https://websiteoss.ecoflow.com/upload/image/1774858323812/UK-M-2.jpg' : 'https://websiteoss.ecoflow.com/upload/image/1774858280157/M22.jpg',
            },
            {
                tabLabel: t.rich('tab3', {
                    sup: (text: string) => <sup>{text}</sup>,
                }),
                tabValue: 'tab3',
                desc: t.rich('tab3_desc', {
                    sup: (text: string) => <sup>{text}</sup>,
                }),
                pc: locale === 'uk' ? 'https://websiteoss.ecoflow.com/upload/image/1774858324236/UK-3.jpg' : 'https://websiteoss.ecoflow.com/upload/image/1774858077196/33.jpg',
                h5: locale === 'uk' ? 'https://websiteoss.ecoflow.com/upload/image/1774858323601/UK-M-3.jpg' : 'https://websiteoss.ecoflow.com/upload/image/1774858280335/M33.jpg',
            },

        ];
    }

    const onChange = (item: any, index: number) => {
        setActiveIndex(index);
        swiperRef.current.slideTo(index);
    };

    const handleSlideChange = (swiper: any) => {
        const index = swiper.realIndex; //下标
        setActiveIndex(index);
    };

    return (
        <div className={`${styles.ChargeUp} GtmModuleData-section`} data-section-id="d3c-ChargeUp">
            <EcoSpace hPc="160px" hPad="100px" hH5="100px" />
            <CommonTitle
                title={t.rich('title', {
                    sup: (text: string) => <sup>{text}</sup>,
                })}
            />
            <AnimatedGrid variant="fadeInUp" options={{ stagger: 0.2, delay: 200, threshold: 0.2 }}>
                <div className="swiper-chargeup d3m-layout">
                    <Swiper
                        onSwiper={(swiper) => {
                            swiperRef.current = swiper;
                        }}
                        slidesPerView={1}
                        spaceBetween={12}
                        speed={1200}
                        modules={[Navigation]}
                        navigation={{
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev',
                        }}
                        initialSlide={0}
                        onSlideChange={handleSlideChange}
                    >
                        {tabs.map((item, index) => (
                            <SwiperSlide key={index} className="list-item">
                                {item.isVideo &&
                                    (isH5 ? (
                                        <div className="eco-video" key={'h5'}>
                                            <video playsInline muted autoPlay loop className="eco-video" poster={item.h5Poster}>
                                                <source src={item.h5} />
                                            </video>
                                        </div>
                                    ) : (
                                        // <EcoVideo key={1} pc={item.h5} poster={item.h5Poster} autoPlay={true} loop={true} />
                                        <div className="eco-video" key={'pc'}>
                                            <video playsInline muted autoPlay loop className="eco-video" poster={item.pcPoster}>
                                                <source src={item.pc} />
                                            </video>
                                        </div>

                                        // <EcoVideo key={2} pc={item.pc} poster={item.pcPoster} autoPlay={true} loop={true} />
                                    ))}
                                {!item.isVideo && <EcoImg pc={item.pc} pad={item.pc} h5={item.h5} isOpenLazy={true} />}
                            </SwiperSlide>
                        ))}
                        <div className="swiper-button-prev" />
                        <div className="swiper-button-next" />
                    </Swiper>
                </div>
            </AnimatedGrid>

            <div className="d3m-tabs">
                <Tabs tabs={tabs} activeIndex={activeIndex} onChange={onChange} />
            </div>
            <div className="footer-desc d3m-layout">{tabs[activeIndex].desc}</div>
            <EcoSpace />
        </div>
    );
};

export default ChargeUp;
